import * as S from './styles';
import React, { useState, useEffect } from "react";
import { CloseButton } from '../alertStyles';
import alert from '../../../assets/image/alert.svg';

const AlertDeleteBenef = ({ onClose, onConfirm, isLoading  }) => {
  const [justification, setJustification] = useState("");

  return (
    <S.ModalOverlay>
      <S.AlertBox>
        <CloseButton onClick={onClose}>x</CloseButton>
        <img src={alert} alt="Emoji Description" />
        <S.AlertTitle 
          value={justification}
          onChange={(e) => setJustification(e.target.value)}>
          Tem certeza que deseja excluir o beneficiário?
          </S.AlertTitle>
        <S.AlertSubtitle>
          Ao prosseguir, todos os dados serão apagados de forma definitiva e não poderão ser recuperados.
        </S.AlertSubtitle>
        <S.ButtonContainer>
          <S.NoButton
          onClick={onClose} disabled={isLoading}>
            Não
            </S.NoButton>
            <S.YesButton onClick={() => onConfirm(justification)} disabled={isLoading}>
              Sim
            </S.YesButton>

        </S.ButtonContainer>
      </S.AlertBox>
    </S.ModalOverlay>
  );
};

export default AlertDeleteBenef;
